export { default } from "./TotalSection";
